module.exports = __webpack_public_path__ + "img/favorite.a8b689fa.svg";